import PropTypes from 'prop-types';

const PageBuild = ({ sections, template, pageSlug, themes }) => {
  const Page = sections.map(({ component }, index) => {
    if (!component) return false;

    const componentType = component.split(' ').join('-').toLowerCase();
    const templateIds = Object.keys(template);
    if (templateIds.includes(componentType)) {
      const Component = template[componentType];
      return (
        <Component
          key={sections[index].id}
          data={sections[index]}
          pageSlug={pageSlug}
          index={index}
          themes={themes}
        />
      );
    }
    console.warn(`Didnt find a component to match the ${component} value`);
    return false;
  });
  return Page;
};

PageBuild.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  template: PropTypes.shape().isRequired,
  pageSlug: PropTypes.string,
  themes: PropTypes.string.isRequired,
};

PageBuild.defaultProps = {
  pageSlug: null,
};

export default PageBuild;
